// export const base_url = 'http://127.0.0.1:8000/api/'
export const base_url = 'https://betaapi.smartcafe.az/api' // api base url